import { Component, OnInit, OnDestroy, ElementRef } from '@angular/core';
import { SettingsService } from '../../core/services/settings.service';
import { ThemesService } from '../../core/services/themes.service';

@Component({
  selector: 'app-offsidebar',
  templateUrl: './offsidebar.component.html',
  styleUrls: ['./offsidebar.component.scss']
})
export class OffsidebarComponent implements OnInit, OnDestroy {

  public currentTheme: any;

  constructor(public settings: SettingsService, public themes: ThemesService, public elem: ElementRef) {
    this.currentTheme = themes.getDefaultTheme();
  }

  public ngOnInit() {
    this.anyClickClose();
  }

  public ngOnDestroy() {
    document.removeEventListener('click', this.checkCloseOffsidebar);
  }

  public setTheme() {
    this.themes.setTheme(this.currentTheme);
  }

  public anyClickClose() {
    document.addEventListener('click', this.checkCloseOffsidebar.bind(this), false);
  }

  public checkCloseOffsidebar(e) {
    const contains = (this.elem.nativeElement !== e.target && this.elem.nativeElement.contains(e.target));
    if (!contains) {
      this.settings.setLayoutSetting('offsidebarOpen', false);
    }
  }
}
